export default __webpack_public_path__ + "static/logo-1d2c3c438ac0ed77684026199c7e2d21.svg";